import React, { useState } from 'react';
import {
  VStack, Input, Select, Textarea, Text, Box, Button, InputGroup,
  InputRightElement, useToast, SimpleGrid
} from '@chakra-ui/react';
import { GoogleMap, Marker, useLoadScript } from '@react-google-maps/api';
import SelectorPerfilUsuario from 'components/PerfilUsuario/SelectorPerfilUsuario';
import { GOOGLE_MAPS_API_KEY } from 'config/googleMaps';

type Modo = 'new' | 'edit' | 'view';

interface Props {
  modo: Modo;
  data?: any;
  onSubmit?: (data: any) => void;
}

const tiposConstancia = [
  'Antigüedad',
  'Ubicación',
  'Seguridad',
  'Estabilidad estructural'
];

const costos = {
  'Antigüedad': 200,
  'Ubicación': 180,
  'Seguridad': 250,
  'Estabilidad estructural': 300,
};

const SolicitudConstancia: React.FC<Props> = ({ modo, data, onSubmit }) => {
  const toast = useToast();

  const [tipo, setTipo] = useState(data?.tipo || '');
  const [responsable, setResponsable] = useState(data?.responsable || '');
  const [direccion, setDireccion] = useState(data?.direccion || '');
  const [lat, setLat] = useState(Number(data?.lat) || 19.4326);
  const [lng, setLng] = useState(Number(data?.lng) || -99.1332);
  const [costo, setCosto] = useState(data?.costo || 0);
  const [observaciones, setObservaciones] = useState(data?.observaciones || '');

  const { isLoaded } = useLoadScript({
    googleMapsApiKey: GOOGLE_MAPS_API_KEY,
    libraries: ['places'],
  });

  const [perfilSeleccionado, setPerfilSeleccionado] = useState<any>(null);

const handlePerfil = (perfil: any) => {
    setPerfilSeleccionado(perfil);
  };
  


  const buscarDireccion = () => {
    const geocoder = new window.google.maps.Geocoder();
    geocoder.geocode({ address: direccion }, (results, status) => {
      if (status === 'OK' && results[0]) {
        const loc = results[0].geometry.location;
        setLat(loc.lat());
        setLng(loc.lng());
        setDireccion(results[0].formatted_address);
      } else {
        toast({
          title: 'Dirección no encontrada',
          description: 'Verifica que la dirección sea válida.',
          status: 'error',
        });
      }
    });
  };

  const calcularCosto = (tipoSeleccionado: string) => {
    setCosto(costos[tipoSeleccionado as keyof typeof costos] || 0);
  };

  const handleGuardar = async () => {
    const payload = {
      tipo,
      responsable,
      direccion,
      lat,
      lng,
      costo,
      observaciones,
      fechaRegistro: new Date()
    };

    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL || "http://127.0.0.1:5000"}/api/obras/solicitud-constancia`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });

      if (!response.ok) throw new Error('Error al guardar solicitud');

      toast({
        title: 'Éxito',
        description: 'Constancia registrada correctamente.',
        status: 'success',
      });

      onSubmit?.(payload);
    } catch (error) {
      toast({
        title: 'Error',
        description: 'Hubo un problema al registrar la constancia.',
        status: 'error',
      });
    }
  };

  if (!isLoaded) return <Text>Cargando mapa...</Text>;

  return (
    <VStack spacing={4} align="stretch">
      {(modo === 'edit' || modo === 'new') ? (
        <>

<SelectorPerfilUsuario onPerfilSeleccionado={handlePerfil} />
          <Select value={tipo} placeholder="Tipo de constancia" onChange={(e) => { setTipo(e.target.value); calcularCosto(e.target.value); }}>
            {tiposConstancia.map((op) => (
              <option key={op} value={op}>{op}</option>
            ))}
          </Select>
          <Text><strong>Costo estimado:</strong> ${costo}</Text>
          <Input placeholder="Responsable" value={responsable} onChange={(e) => setResponsable(e.target.value)} />
          <InputGroup>
            <Input placeholder="Dirección" value={direccion} onChange={(e) => setDireccion(e.target.value)} />
            <InputRightElement width="4.5rem">
              <Button h="1.75rem" size="sm" onClick={buscarDireccion}>Buscar</Button>
            </InputRightElement>
          </InputGroup>
          <Box h="200px" w="100%">
            <GoogleMap zoom={15} center={{ lat, lng }} mapContainerStyle={{ width: '100%', height: '100%' }}>
              <Marker
                position={{ lat, lng }}
                draggable
                onDragEnd={(e) => {
                  setLat(e.latLng?.lat() || lat);
                  setLng(e.latLng?.lng() || lng);
                }}
              />
            </GoogleMap>
          </Box>
          <Textarea placeholder="Observaciones" value={observaciones} onChange={(e) => setObservaciones(e.target.value)} />
          <Button colorScheme="green" onClick={handleGuardar}>
            {modo === 'new' ? 'Registrar' : 'Actualizar'}
          </Button>
        </>
      ) : (
        <>
          <SimpleGrid columns={2} spacing={4}>
            <Box>
              <Text><strong>Tipo:</strong> {tipo}</Text>
              <Text><strong>Responsable:</strong> {responsable}</Text>
              <Text><strong>Dirección:</strong> {direccion}</Text>
              <Text><strong>Costo:</strong> ${costo}</Text>
            </Box>
            <Box>
              {observaciones && <Text><strong>Observaciones:</strong> {observaciones}</Text>}
            </Box>
          </SimpleGrid>
          <Box h="200px" w="100%">
            <GoogleMap zoom={15} center={{ lat, lng }} mapContainerStyle={{ width: '100%', height: '100%' }}>
              <Marker position={{ lat, lng }} />
            </GoogleMap>
          </Box>
        </>
      )}
    </VStack>
  );
};

export default SolicitudConstancia;
